<template>
    <div class="register-container">
        <div class="register-box">
            <h2>注册账号</h2>
            <div class="form-group">
                <input v-model="username" type="text" placeholder="用户名" required />
            </div>
            <div class="form-group">
                <input v-model="password" type="password" placeholder="密码" required />
            </div>
            <div class="form-group">
                <input v-model="confirmPassword" type="password" placeholder="确认密码" required />
            </div>
            <button @click="handleRegister" class="register-btn">注册</button>
            <div class="links">
                <router-link to="/login">已有账号？返回登录</router-link>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'RegisterView',
    data() {
        return {
            username: '',
            password: '',
            confirmPassword: '',
        };
    },
    methods: {
        async handleRegister() {
            if (this.password !== this.confirmPassword) {
                alert('两次输入的密码不一致');
                return;
            }

            try {
                const response = await fetch('/api/auth/register', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify({
                        username: this.username,
                        password: this.password,
                    }),
                });

                const data = await response.json();

                if (response.ok) {
                    alert('注册成功！');
                    this.$router.push('/login');
                } else {
                    alert(data.message || '注册失败');
                }
            } catch (error) {
                console.error('注册错误:', error);
                alert('注册失败，请稍后重试');
            }
        },
    },
};
</script>

<style scoped lang="scss">
.register-container {
    height: 100vh;
    display: flex;
    justify-content: center;
    align-items: center;
    background: url('../assets/images/background.jpg') no-repeat center center;
    background-size: cover;
}

.register-box {
    background: rgba(255, 255, 255, 0.9);
    padding: 2rem;
    border-radius: 8px;
    box-shadow: 0 0 20px rgba(0, 0, 0, 0.2);
    width: 300px;
}

// 其他样式与 Login.vue 相同
</style>
